import { action, extendObservable, observe } from 'mobx'

export default class Modal {
  constructor() {
    extendObservable(this, {
      error: null,
      content: null,
      config: {},
      props: {}
    })

    this.waitingToOpen = []
    observe(this, async change => {
      if (!change.object.type) {
        const newParams = this.waitingToOpen.pop()
        if (newParams) {
          this.show({
            type: newParams.type,
            props: newParams.props
          })
        }
      }
    })
  }

  show = action(({ type, props }) => {
    if (!this.type) {
      this.type = type
      this.props = props || {}
      this.config = { isOpen: true }
    } else {
      this.waitingToOpen.push({ type: type, props: props })
    }
  })

  close = action(() => {
    this.config = {}
    this.type = null
    this.props = {}
  })
}
